import { route, publicUrlFor } from "../../../../globals/constants";
import FastImage from "../../../../globals/elements/fastimg";
import { NavLink } from "react-router-dom";
import { renderContactInfo } from "../../../../utils";
import { useEffect, useState } from "react";
import {
    getGoodsList
} from '../../../../utils/func'

function SectionFooter1({
    theme,
    layoutInfo,
}) {

    const [goodsList, setGoodsList] = useState([])

    useEffect(() => {

        getGoodsList(1, 3).then(result => {
            setGoodsList(result)
        }).catch(err => {

        })

        return () => {

        }
    }, [])



    return (
        <>
            <footer className={"site-footer " + theme}>
                {/* Footer Top Part */}
                <div className="footer-top overlay-wraper">
                    <div className="overlay-main" />
                    <div className="container">
                        <div className="row">
                            {/* About */}
                            <div className="col-lg-3 col-md-6">
                                <div className="widget widget_about">
                                    <h4 className="widget-title">About Company</h4>
                                    <div className="logo-footer clearfix p-b15">
                                        <NavLink to={route.home.HOME1}><FastImage src={layoutInfo?.logo} width={171} height={49} alt="" /></NavLink>
                                    </div>
                                    <p>{layoutInfo?.description}</p>
                                    <ul>
                                        <li> <i className="fa fa-phone site-text-primary" /> <b className="p-lr5 text-uppercase">Phone :</b> {renderContactInfo(layoutInfo?.contact_number)} </li>
                                        <li><i className="fa fa-envelope site-text-primary" /> <b className="p-lr5 text-uppercase">Email : </b>{renderContactInfo(layoutInfo?.email)}</li>
                                        <li><i className="fa fa-location-arrow site-text-primary" /> <b className="p-lr5 text-uppercase">Address :</b>{layoutInfo?.company_address}</li>
                                    </ul>
                                </div>
                            </div>
                            {/* Useful Links */}
                            <div className="col-lg-3 col-md-6">
                                <div className="widget widget_services">
                                    <h4 className="widget-title">Link</h4>
                                    <ul>
                                        <li><NavLink to={route.pages.ABOUT}>About US</NavLink></li>
                                        <li><NavLink to={route.pages.FAQ}>FAQ</NavLink></li>
                                        <li><NavLink to={route.pages.team.TEAM}>Our Team</NavLink></li>
                                        <li><NavLink to={route.services.SERVICES}>Our Services</NavLink></li>
                                        <li><NavLink to={route.pages.gallery.GALLERY1}>Gallery</NavLink></li>
                                        {/* <li><NavLink to={route.shop.PRODUCTS}>Shop</NavLink></li> */}
                                        {/* <li><NavLink to={route.blog.GRID}>Blog</NavLink></li> */}
                                    </ul>
                                </div>
                            </div>
                            {/* Resent Post */}
                            <div className="col-lg-3 col-md-6">
                                <div className="widget recent-posts-entry-date">
                                    <h4 className="widget-title">Resent Products</h4>
                                    <div className="widget-post-bx">
                                        {
                                            goodsList && goodsList.length > 0 && goodsList.map((item,index) => {
                                                return (
                                                    <div className="widget-post clearfix" key={`itme-${index}`}>
                                                        <div className="mt-post-media text-white  overflow-hide">
                                                            <FastImage src={item?.img} alt="" />
                                                        </div>
                                                        <div className="mt-post-info">
                                                            <div className="mt-post-header">
                                                                <div className="post-title">
                                                                    <NavLink to={`${route.shop.DETAIL}/${item?.id}`}>{item.title}</NavLink>
                                                                </div>
                                                            </div>
                                                            <div className="mt-post-meta">
                                                                <ul>
                                                                    <li className="post-author"><i className="fa fa-user site-text-primary" />By Admin</li>
                                                                    <li className="post-comment"><i className="fa fa-comments site-text-primary" /> 28</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }

                                    </div>
                                </div>
                            </div>
                            {/* Instagram Feed */}
                            <div className="col-lg-3 col-md-6">
                                <div className="widget widget_newsletter f-news-letter">
                                    <h4 className="widget-title">Subscribe</h4>
                                    <div className="newsletter-bx m-b30">
                                        <form role="search" method="post">
                                            <div className="input-group">
                                                <input name="news-letter" className="form-control" placeholder="Enter your email" type="text" />
                                                <span className="input-group-btn">
                                                    <button type="submit" className="site-button btn font-weight-600"><i className="fa fa-paper-plane" /></button>
                                                </span>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="widget widget_gallery mfp-gallery clearfix">
                                    <h4 className="widget-title">Gallery</h4>
                                    <ul className="clearfix">
                                        <li>
                                            <div className="mt-post-thum  overflow-hide">
                                                <a href={publicUrlFor("images/gallery/pic1.jpg")} className="mfp-link"><FastImage src={publicUrlFor("images/gallery/thumb/pic1.jpg")} alt="" /></a>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="mt-post-thum  overflow-hide">
                                                <a href={publicUrlFor("images/gallery/pic2.jpg")} className="mfp-link"><FastImage src={publicUrlFor("images/gallery/thumb/pic2.jpg")} alt="" /></a>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="mt-post-thum  overflow-hide">
                                                <a href={publicUrlFor("images/gallery/pic3.jpg")} className="mfp-link"><FastImage src={publicUrlFor("images/gallery/thumb/pic3.jpg")} alt="" /></a>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="mt-post-thum  overflow-hide">
                                                <a href={publicUrlFor("images/gallery/pic4.jpg")} className="mfp-link"><FastImage src={publicUrlFor("images/gallery/thumb/pic4.jpg")} alt="" /></a>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="mt-post-thum  overflow-hide">
                                                <a href={publicUrlFor("images/gallery/pic5.jpg")} className="mfp-link"><FastImage src={publicUrlFor("images/gallery/thumb/pic5.jpg")} alt="" /></a>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="mt-post-thum  overflow-hide">
                                                <a href={publicUrlFor("images/gallery/pic6.jpg")} className="mfp-link"><FastImage src={publicUrlFor("images/gallery/thumb/pic6.jpg")} alt="" /></a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Footer Copyright Part */}
                <div className="footer-bottom overlay-wraper">
                    <div className="overlay-main" />
                    <div className="container p-t30">
                        <div className="mt-footer-bot-center">
                            <span className="copyrights-text">{`© ${new Date().getFullYear()} ${layoutInfo?.company_name} All Rights Reserved.`} <a href="https://beian.miit.gov.cn/#/Integrated/index" target="__blank">{layoutInfo?.beian}</a></span>
                        </div>
                    </div>
                </div>
            </footer>

        </>
    )
}
export default SectionFooter1;